import apiClient from "@repo/ui/lib/apiClient";
import { getTabSessionId } from "@repo/ui/lib/tabSessionId";

const NEW_TOKEN_ENDPOINT = "v1/session/token";

/**
 * Get a new anonymous token for the current session
 * This is a standalone utility that can be used anywhere without context
 *
 * @returns Promise<boolean> - true if successful, false otherwise
 */
export async function getNewToken(): Promise<boolean> {
  try {
    const tabSessionId = getTabSessionId();
    if (!tabSessionId) {
      console.error("[TokenRefresh] No tab session ID found");
      return false;
    }

    await apiClient(NEW_TOKEN_ENDPOINT, {
      method: "GET",
      tabSessionId,
    });

    return true;
  } catch (error) {
    console.error("[TokenRefresh] Error getting new token:", error);
    return false;
  }
}
